import React, { useMemo } from 'react';
import { notNil } from '@shared/util/notNil';
import { MBChannelChatBanner } from './channel';
import { MBDMChatBanner } from './dm';
import { MBMeChatBanner } from './me';

interface MBChatBannerProps {
  channel: MBAPI.ChannelChatThread;
  creator: MBAPI.ShortUser;
  currentUserId?: number;
}

/*
    Chat channel banner at the top of every chat thread.
*/
export function MBChatBannerComponent({ channel, creator, currentUserId }: MBChatBannerProps) {
  const users = useMemo(() => channel.users.filter(notNil) ?? [], [channel.users]);

  // Clicking Support opens the intercom UI, not a workspace
  if (channel.type === 'SUPPORT') {
    return null;
  }

  // If chatting with myself
  if (channel.type === 'DM' && users.length === 1) {
    return <MBMeChatBanner channel={channel} user={users[0]} />;
  }

  if (channel.type === 'DM' && users.length === 2) {
    const otherUser = users.find(u => u.id !== currentUserId);
    if (otherUser) {
      return <MBDMChatBanner channel={channel} user={otherUser} />;
    }
  }

  return <MBChannelChatBanner channel={channel} creator={creator} />;
}
